import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {
    GameSessionPromotionEvents,
    GameSessionPromotionModule
} from '@gongxigames/framework/promotions/';

export class GameSessionPromotionDisabledState extends ModuleState<null, GameSessionPromotionModule, GameSessionPromotionEvents> {
    public onEnterState(): void {}
    public onLeaveState(): void {}
    protected setupEvents(): void {}
}
